import { inject, Injectable } from '@angular/core';
import padWithZeros from '@core/utils/padWithZeros';
import {
  RealtimeIsActiveSelector,
  SetVariablesDataAction,
  SetVariablesPayloadType,
  ToDateSelector,
} from '@dashboard/dashboard-store';
import { IngestionErrorEvaluationData } from '@dashboard/dashboard-store/selectors/system-errors.selector';
import { Store } from '@ngrx/store';
import moment, { Moment } from 'moment';
import { firstValueFrom, Subscription, timer } from 'rxjs';
import { EnvVarsService } from '../../../../env-vars.service';

@Injectable()
export class SystemDataErrorsService {
  private _store = inject(Store);
  private environment = inject(EnvVarsService);

  private VESSEL_OFFLINE_TIMEOUT_HOURS =
    this.environment.getEnvKey('VESSEL_OFFLINE_TIMEOUT_HOURS') || 2;
  private $IngestionTimer: Subscription;

  public InitIngestionErrorChecker() {
    console.debug('Ingestion Error Timer Started');

    // const rangeToEndOfSeocondMin =
    //   moment().endOf('minute').diff(moment())
    const TenSecsInMs = 10_000;
    const AnHourMs = 3_600_000;

    this.$IngestionTimer = timer(TenSecsInMs, AnHourMs).subscribe(() => {
      this.IngestionErrorChecker();
    });
  }

  public stopIngestionErrorChecker() {
    this.$IngestionTimer.unsubscribe();
  }

  public async IngestionErrorChecker() {
    const vesselsData = await firstValueFrom(
      this._store.select(IngestionErrorEvaluationData)
    );
    const selectedDate = await firstValueFrom(
      this._store.select(ToDateSelector)
    );

    const isRealTime = await firstValueFrom(
      this._store.select(RealtimeIsActiveSelector)
    );

    const variableMeta = vesselsData
      .map((d) => ({
        hasError: this.IgestionHasErrorRule(
          isRealTime ? moment() : moment(selectedDate).utc(),
          d.systemHealth,
          d.latest_timestamp * 1000
        ),
        imo: d.imo,
      }))
      .map(({ imo, hasError }) => {
        const payload: SetVariablesPayloadType = [
          padWithZeros(imo, 8),
          'ingestion_error',
          {
            notInSync: false,
            variableId: 'ingestion_error',
            timestamp: moment().valueOf() / 1000,
            formattedValue: `${hasError}`,
          },
        ];
        return payload;
      });

    this._store.dispatch(
      SetVariablesDataAction({ variableMeta, source: 'API' })
    );
  }

  private IgestionHasErrorRule(
    selectedDateUtc: Moment,
    systemHealth: string,
    state_timestamp_ms: number
  ) {
    /**
     * We need to validate by checkign the timezone. So we need to check in the UTC. Since state timestamp is in utc
     */

    const StateTimestampUtc = moment.utc(state_timestamp_ms);
    const range = selectedDateUtc.diff(StateTimestampUtc, 'hours', true);
    const HoursArePassed = Math.abs(range) > this.VESSEL_OFFLINE_TIMEOUT_HOURS;

    const statusIsOffline = systemHealth === 'offline';

    return HoursArePassed || statusIsOffline;
  }
}
